import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useDeviceFormat } from "@/hooks/useDeviceFormat";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { LuZap } from "react-icons/lu";

type PromptTriggerButtonProps = {
  onClick: () => void;
  className?: string;
};

export default function PromptTriggerButton({
  onClick,
  className,
}: PromptTriggerButtonProps) {
  const { t } = useTranslation();
  const { isMobile } = useDeviceFormat();

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size={isMobile ? "icon" : "sm"}
          onClick={onClick}
          className={cn("h-9 text-sm shadow-none [&>span]:line-clamp-1", className)}
        >
          <LuZap className="size-4" />
          {!isMobile && <span>{t("chat.input.prompts.title")}</span>}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        <p>{t("chat.input.prompts.select")}</p>
      </TooltipContent>
    </Tooltip>
  );
}
